import React from 'react';
import { TBehavioralHealth } from 'types/insuranceEligibility';
import { BH_COPY } from '../copy';
import { payerProse } from '../derive';
import s from '../s.module.less';

type Props = {
    bh: TBehavioralHealth;
    // 271 payer 名（已过 payerProse）
    payerName?: string;
};

// 实心图标（原型 CHECK_ICON / WARN_ICON）：填充色 + 白色笔画
const CHECK_ICON = (
    <svg viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#34D399" />
        <path d="M6 10.5l2.5 2.5L14 7.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const WARN_ICON = (
    <svg viewBox="0 0 20 20" fill="none">
        <path
            d="M9.14 2.88a1 1 0 0 1 1.72 0l8.14 14.12a1 1 0 0 1-.86 1.5H1.86a1 1 0 0 1-.86-1.5z"
            fill="currentColor"
        />
        <path d="M10 7.4v4" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" />
        <circle cx="10" cy="14.7" r="1.05" fill="#fff" />
    </svg>
);

// 绿框（payer 直管 BH）或琥珀 carve-out 框（点名管理方，上方金额不适用）。
// payerName 已过 payerProse；管理方名（271 marker，如 'OPTUM'）这里再过一次 title-case
const BhBlock: React.FC<Props> = ({ bh, payerName }) => {
    const payer = payerName || 'This payer';
    if (bh.carveOut) {
        const admin = bh.carveOut.administratorName ? payerProse(bh.carveOut.administratorName) : undefined;
        return (
            <div className={`${s.bhBlock} ${s.bhCarve}`}>
                <div className={s.bhTitle}>
                    {WARN_ICON}
                    {BH_COPY.carveTitle}
                </div>
                <div className={s.bhBody}>
                    {admin ? (
                        <>
                            <b>{admin}</b>
                            {BH_COPY.carveWho(payer)}
                        </>
                    ) : (
                        BH_COPY.carveNoAdmin(payer)
                    )}
                    {BH_COPY.carveTailLead}
                    <b>{BH_COPY.carveTailBold}</b>
                    {BH_COPY.carveTailEnd}
                </div>
            </div>
        );
    }
    if (!bh.covered) {
        return null;
    }
    return (
        <div className={s.bhBlock}>
            <div className={s.bhTitle}>
                {CHECK_ICON}
                {BH_COPY.coveredTitle(bh.serviceType)}
            </div>
            <div className={s.bhBody}>
                {BH_COPY.coveredBody(payer)}
                {bh.visitLimit && (
                    <>
                        {' '}
                        {BH_COPY.visitLimitLead}
                        <b>{BH_COPY.visitLimitBold(bh.visitLimit.quantity)}</b>
                        {/* 周期插语：VISIT/缺省走裸句（词表没有该周期的插语时同样沉默） */}
                        {(bh.visitLimit.period && BH_COPY.visitLimitPer[bh.visitLimit.period]) || ''}
                        {BH_COPY.visitLimitTail}
                    </>
                )}
                {bh.visitLimit?.note && ` ${bh.visitLimit.note}`}
            </div>
        </div>
    );
};

export default BhBlock;
